import * as threeApi from '@/api/3d';

// 模型列表缓存：按「项目ID + 是否系统模型」缓存，30 秒 TTL。
// 页面打开时走缓存秒开；上传/删除/重命名/刷新等变更操作传 force=true 强制拉新。
const modelListCache = new Map();
const MODEL_LIST_TTL = 30 * 1000;

const state = () => ({
  modelList: [],
  sceneList: [],
  currentScene: null,
});

const mutations = {
  SET_MODEL_LIST(state, list) {
    state.modelList = list;
  },
  SET_SCENE_LIST(state, list) {
    state.sceneList = list;
  },
  SET_CURRENT_SCENE(state, scene) {
    state.currentScene = scene;
  },
};

const actions = {
  // 获取模型列表（支持缓存；params.force=true 绕过缓存）
  getModelList({ commit }, params) {
    return new Promise((resolve, reject) => {
      const cacheKey = `${params.project_id || 'global'}:${params.is_system !== undefined ? String(params.is_system) : ''}`;
      const cached = modelListCache.get(cacheKey);
      if (!params.force && cached && Date.now() - cached.ts < MODEL_LIST_TTL) {
        resolve(cached.data);
        return;
      }
      threeApi
        .getModelList(params)
        .then((res) => {
          // 修复：后端返回 code=0, message="OK"，不是 code="OK"
          if (res.code === 0 || res.message === 'OK') {
            const list = res.data?.list || res.data?.models || [];
            commit('SET_MODEL_LIST', list);
            modelListCache.set(cacheKey, { ts: Date.now(), data: res });
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 上传模型
  uploadModel(_context, data) {
    return new Promise((resolve, reject) => {
      threeApi
        .uploadModel(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 删除模型
  deleteModel(_context, params) {
    return new Promise((resolve, reject) => {
      threeApi
        .deleteModel(params)
        .then((res) => {
          // 修复：后端返回 code=0, message="OK"，不是 code="OK"
          if (res.code === 0 || res.message === 'OK') {
            // 可以在这里添加刷新列表的逻辑
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 更新模型缩略图（补生成/替换）
  updateModelThumbnail(_context, data) {
    return new Promise((resolve, reject) => {
      threeApi
        .updateModelThumbnail(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 重命名模型
  renameModel(_context, data) {
    return new Promise((resolve, reject) => {
      threeApi
        .renameModel(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 获取场景列表
  getSceneList({ commit }, params) {
    return new Promise((resolve, reject) => {
      threeApi
        .getSceneList(params)
        .then((res) => {
          // 修复：后端返回 code=0, message="OK"，不是 code="OK"
          if (res.code === 0 || res.message === 'OK') {
            const list = res.data?.list || [];
            commit('SET_SCENE_LIST', list);
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 获取场景详情
  getSceneDetail({ commit }, params) {
    return new Promise((resolve, reject) => {
      threeApi
        .getSceneDetail(params)
        .then((res) => {
          // 修复：后端返回 code=0, message="OK"，不是 code="OK"
          if (res.code === 0 || res.message === 'OK') {
            commit('SET_CURRENT_SCENE', res.data);
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 保存场景（新建）
  saveScene(_context, data) {
    return new Promise((resolve, reject) => {
      threeApi
        .saveScene(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 更新场景
  updateScene(_context, data) {
    return new Promise((resolve, reject) => {
      threeApi
        .updateScene(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 发布场景
  publishScene(_context, data) {
    return new Promise((resolve, reject) => {
      threeApi
        .publishScene(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 删除场景
  deleteScene(_context, params) {
    return new Promise((resolve, reject) => {
      threeApi
        .deleteScene(params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  // 获取场景变量数据
  getSceneVariables(_context, params) {
    return new Promise((resolve, reject) => {
      threeApi
        .getSceneVariables(params)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
